import useIntl from 'hooks/useIntl';

const EmptyCheckout = () => {
	const { t } = useIntl('checkout');
	return <div>{t('emptyCheckoutInfo')}</div>;
};

export default EmptyCheckout;
